import { z } from 'zod';

/** Last-used export options, separate from a design and its published revisions. Placeholder strings are customer content. */
export const DESIGN_EXPORT_PLATFORMS = ['none', 'afterbuy', 'dreamrobot', 'eazyAuction', 'magnalister', 'plentyMarkets'] as const;
export const DesignExportPlatform = z.enum(DESIGN_EXPORT_PLATFORMS);
export type DesignExportPlatform = z.infer<typeof DesignExportPlatform>;
/** Matches the legacy export form and the existing PAT4 dialog. */
export const MAX_EXPORT_PICTURES = 12;
const Placeholder = z.string().max(2000);
export const DesignExportSettings = z.object({
  platform: DesignExportPlatform,
  pictures: z.boolean(),
  picturePosition: z.enum(['below', 'above']),
  pictureFormat: z.enum(['list', 'preview-top', 'preview-bottom']),
  title: Placeholder,
  description: Placeholder,
  picturePlaceholders: z.array(Placeholder).max(MAX_EXPORT_PICTURES),
  eazyAuctionPictureCount: z.number().int().min(0).max(MAX_EXPORT_PICTURES),
  output: z.enum(['text', 'file']),
  fileExtension: z.enum(['txt', 'html']),
  plentyVersion: z.union([z.literal(6), z.literal(7)]),
});
export type DesignExportSettings = z.infer<typeof DesignExportSettings>;
